module.exports = __webpack_public_path__ + "f4df2c24784e9a9f69d9b02ea94c0828.pdf";